module.exports = __webpack_public_path__ + "img/horizontal_2_1_r_2.e8f1a13e.png";